import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Box, Card, Flex, Text } from '../design-system';
import {
  addStoText,
  filterHelper,
  filterWhereExists,
  CLOSED_STATUSES,
  errorMsg,
} from '../helpers/utils';
import { useData } from '../helpers/data-loader';

const StyledCard = styled(Card)`
  box-shadow: 0px 0px 10px #d7d7d7;
`;

const CardBody = styled(Card.Body)`
  padding-top: 20px !important;
  padding-bottom: 24px;
`;

const Quantity = styled(Text)`
  display: block;
  font-size: 2rem;
  font-weight: 700;
`;

interface YearToDateCardProps {
  data?: any;
  activeSection?: { title: string; value: any };
  height?: any;
}

const YearToDateCard = ({
  data,
  activeSection,
  height,
}: YearToDateCardProps) => {
  const [ytdData, fetchData] = useData(`/project/ytdData`, {
    errorMsg: errorMsg('YTD Data'),
    initialLoading: true,
  });

  const projects = !data ? ytdData.projects : data;
  const clientCount = !data ? ytdData.clientCount : data.length;

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const completedProjects = filterWhereExists(
    projects,
    'status',
    CLOSED_STATUSES,
  );
  const projectsAwarded = filterHelper(projects, 'status', 'Awarded');
  const projectsPending = filterHelper(projects, 'status', 'Pending');

  return (
    <StyledCard id="year-to-date-card" height={height}>
      <Card.Header fontSize={20}>Year to Date</Card.Header>
      <CardBody>
        <Flex>
          <Box textAlign="center" m={2} p={2} flex={1}>
            <Quantity>{clientCount || 0}</Quantity>
            <span>
              {activeSection
                ? activeSection.title + addStoText(activeSection.value)
                : `Active Client${addStoText(clientCount)}`}
            </span>
          </Box>
          <Box textAlign="center" m={2} p={2} flex={1}>
            <Quantity>
              {completedProjects && completedProjects.length
                ? completedProjects.length
                : 0}
            </Quantity>
            <span>
              Finished Project
              {addStoText(completedProjects ? completedProjects.length : 0)}
            </span>
          </Box>
        </Flex>
        <Flex>
          <Box textAlign="center" m={2} p={2} flex={1}>
            <Quantity>{projectsAwarded || 0}</Quantity>
            <span>Project{addStoText(projectsAwarded)} Awarded</span>
          </Box>
          <Box textAlign="center" m={2} p={2} flex={1}>
            <Quantity>{projectsPending || 0}</Quantity>
            <span>Project{addStoText(projectsPending)} Pending</span>
          </Box>
        </Flex>
      </CardBody>
    </StyledCard>
  );
};

export default YearToDateCard;
